import { Permission } from './permission.types';

export const hasAccess = (
  routeKey: string | undefined,
  permissions: Permission[] | undefined
): boolean => {
  try {
  
    if (!routeKey) {
      return false;
    }

    if (!Array.isArray(permissions)) {
      return false;
    }

    const normalizedRouteKey = routeKey.toLowerCase().trim();

    // ✅ SUPER ADMIN access
    const isSuperAdmin = permissions.some(
      p => p?.key?.toLowerCase().trim() === 'all' && p.manage === true
    );

    if (isSuperAdmin) {
      return true;
    }

    // 🔍 Find permission
    const perm = permissions.find(
      p => p?.key?.toLowerCase().trim() === normalizedRouteKey
    );

    if (!perm) {
      return false;
    }

    // 🔐 manage = full access
    if (perm.manage) return true;

    return Boolean(perm.read);

  } catch (error) {
    return false; // fail closed (secure default)
  }
};

export type ArticlePermissionAction = 'create' | 'read' | 'update' | 'delete' | 'review' | 'publish';

/** Article actions stay separate. manage on all, or manage on Article, still allows every action. */
export const hasArticlePermission = (
  permissions: Permission[] | undefined,
  action: ArticlePermissionAction
): boolean => {
  if (!Array.isArray(permissions)) return false;

  const isSuperAdmin = permissions.some(
    (item) => item?.key?.toLowerCase().trim() === 'all' && item.manage === true
  );
  if (isSuperAdmin) return true;

  const article = permissions.find((item) => item?.key?.toLowerCase().trim() === 'article');
  if (!article) return false;
  if (article.manage) return true;
  return Boolean(article[action]);
};





// import { Permission } from './permission.types';

// export const hasAccess = (
//   routeKey: string | undefined,
//   permissions: Permission[]
// ): boolean => {

//   if (permissions?.some(p => p.key.toLocaleLowerCase().trim() === 'all' && p.manage)) {
//     console.log("Access granted: User is SUPER ADMIN");
//     return true;
//   }

//   const perm = permissions?.find(p => p.key.trim() === routeKey?.toLocaleLowerCase().trim());
//   if (!perm) return false;

//   // manage = everything
//   if (perm.manage) return true;

//   return !!perm.read;
// };
